import Vue from 'vue';
import Router from 'vue-router';
import VueRouter from 'vue-router';
import aboutUs from './aboutUs';
Vue.use(Router);

// 解决点击重复路由报错问题

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/main/index.vue'),
    /* 因为/是根路径，所以可以直接写main */
    redirect: 'main',
    children: [
      {
        path: 'main',
        name: 'main',
        meta: { title: '首页' },
        component: () => import('../views/main/index.vue'),
      },
    ],
  },
  {
    path: '/invest',
    name: 'invest',
    meta: {
      title: '投资陪伴',
    },
    component: () => import('../views/investCompanion/index.vue'),
  },
  {
    path: '/info-dis',
    name: 'info-dis',
    meta: {
      title: '信息披露',
    },
    component: () => import('../views/infoDis/index.vue'),
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: '信息披露',
    },
    component: () => import('../views/aboutUs/index.vue'),
  },
  {
    path: '/product',
    name: 'product',
    meta: {
      title: '公募理财',
    },
    component: () => import('@/views/product/list.vue'),
  },
  {
    path: '/product-detail',
    name: 'product-detail',
    meta: {
      title: '公募理财',
    },
    component: () => import('@/views/product/detail.vue'),
  },
  {
    path: '/pri-product',
    name: 'pri-product',
    meta: {
      title: '私募理财',
    },
    component: () => import('@/views/pri/list.vue'),
  },
  {
    path: '/pri-notice',
    name: 'pri-notice',
    meta: {
      title: '私募公告',
    },
    component: () => import('@/views/prinotice/index.vue'),
  },
  {
    path: '/pri-product-detail',
    name: 'pri-product-detail',
    meta: {
      title: '私募理财',
    },
    component: () => import('@/views/pri/detail.vue'),
  },
  {
    path: '/employee',
    name: 'employee',
    meta: {
      title: '公司员工',
    },
    component: () => import('@/views/aboutUs/employee.vue'),
  },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => import('@/views/user/Register.vue'),
  // },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('@/views/user/Login.vue'),
  // },
  // {
  //   path: '/user/index',
  //   name: 'user-index',
  //   component: () => import('@/views/user/Index.vue'),
  // },
  {
    path: '/user/act',
    name: 'user-act',
    component: () => import('@/views/user/usract/Index.vue'),
  },
  {
    path: '/user/hold',
    name: 'user-hold',
    component: () => import('@/views/user/hold/Hold.vue'),
  },
  {
    path: '/reset-pwd',
    name: 'reset-pwd',
    component: () => import('@/views/user/ResetPwd.vue'),
  },
  {
    path: '/user/trd-apl-lst',
    name: 'user-trd-apl-lst',
    component: () => import('@/views/user/trade/ApplyList.vue'),
  },
  {
    path: '/user/trd-cmf-lst',
    name: 'user-trd-cmf-lst',
    component: () => import('@/views/user/trade/ConfirmList.vue'),
  },
  {
    path: '/user/bonus',
    name: 'user-bonus',
    component: () => import('@/views/user/bonus/List.vue'),
  },
  ...aboutUs,
];

export default new Router({ routes });
